

// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import emailjs from 'emailjs-com';
// import './Signup.css';

// function SignupContainer({ setShowSignup }) {
//   const [step, setStep] = useState(1);
//   const [profileFor, setProfileFor] = useState('');
//   const [gender, setGender] = useState('');
//   const [firstName, setFirstName] = useState('');
//   const [lastName, setLastName] = useState('');
//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const [confirmPassword, setConfirmPassword] = useState('');
//   const [error, setError] = useState(null);
//   const [otp, setOtp] = useState('');
//   const [generatedOtp, setGeneratedOtp] = useState('');
//   const [otpTimer, setOtpTimer] = useState(60);
//   const [resendDisabled, setResendDisabled] = useState(true);
//   const [otpValid, setOtpValid] = useState(true);

//   const navigate = useNavigate();

//   useEffect(() => {
//     let countdown;

//     if (step === 3 && otpTimer > 0) {
//       countdown = setInterval(() => {
//         setOtpTimer((prev) => prev - 1);
//       }, 1000);
//     }

//     if (otpTimer === 0) {
//       clearInterval(countdown);
//       setOtpValid(false);
//       setResendDisabled(false);
//     }

//     return () => clearInterval(countdown);
//   }, [otpTimer, step]);

//   const handleProfileSelect = (option) => {
//     setProfileFor(option);
//     if (option === 'My Son' || option === 'My Brother') setGender('Male');
//     else if (option === 'My Daughter' || option === 'My Sister') setGender('Female');
//     else setGender('');
//   };

//   const handleGenderSelect = (option) => {
//     setGender(option);
//   };

//   const handleContinue = () => {
//     if (profileFor && gender) setStep(2);
//   };

//   const generateOtp = () => {
//     const otpCode = Math.floor(10000 + Math.random() * 90000).toString();
//     setGeneratedOtp(otpCode);
//     setOtpTimer(60);
//     setOtpValid(true);
//     setResendDisabled(true);

//     const templateParams = {
//       to_email: email,
//       otp: otpCode,
//     };

//     emailjs
//       .send('service_cmd3h5y', 'template_gome033', templateParams, 'DMFmcREENW-DkL8wt')
//       .then(() => {
//         showAlert('OTP sent to your email!');
//       })
//       .catch((error) => {
//         console.error('Error sending OTP: ', error);
//         showAlert('Failed to send OTP. Please try again.');
//       });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (password !== confirmPassword) {
//       setError('Passwords do not match!');
//       return;
//     }

//     setError(null);
//     generateOtp();
//     setStep(3);
//   };

//   const handleOtpSubmit = async (e) => {
//     e.preventDefault();

//     if (!otpValid) {
//       showAlert('OTP has expired. Please resend OTP.');
//       return;
//     }

//     if (otp === generatedOtp) {
//       showAlert('OTP verified successfully!');
//       const userData = {
//         firstName,
//         lastName,
//         email,
//         password,
//         gender,
//         profileFor,
//       };

//       try {
//         const response = await fetch('https://back.varankal.com/auth/signup', {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify(userData),
//         });

//         const data = await response.json();

//         if (response.ok) {
//           setStep(4);
//         } else {
//           alert(data.message || 'Registration failed!');
//         }
//       } catch (error) {
//         console.error('Error during registration:', error);
//         showAlert('An error occurred. Please try again.');
//       }
//     } else {
//       showAlert('Invalid OTP. Please try again.');
//     }
//   };

//   const handleResendOtp = () => {
//     generateOtp();
//   };

//   return (
//     <div className="container9090">
//       {step === 1 && (
//         <div className="profile-gender-container">
//           <h3>This Profile is for</h3>
//           <div className="profile-options">
//             {['Myself', 'My Son', 'My Daughter', 'My Brother', 'My Sister', 'My Friend'].map((option) => (
//               <button key={option} className={profileFor === option ? 'active-btn' : ''} onClick={() => handleProfileSelect(option)}>
//                 {option}
//                 {profileFor === option && <span className="tick">✔</span>}
//               </button>
//             ))}
//           </div>

//           {(profileFor === 'Myself' || profileFor === 'My Friend' || profileFor === 'My Relative') && (
//             <div className="gender-section">
//               <h4>Gender</h4>
//               <div className="gender-options">
//                 <button className={gender === 'Male' ? 'active-btn' : ''} onClick={() => handleGenderSelect('Male')}>
//                   Male {gender === 'Male' && <span className="tick">✔</span>}
//                 </button>
//                 <button className={gender === 'Female' ? 'active-btn' : ''} onClick={() => handleGenderSelect('Female')}>
//                   Female {gender === 'Female' && <span className="tick">✔</span>}
//                 </button>
//               </div>
//             </div>
//           )}

//           <button className="continue-btn" disabled={!profileFor || !gender} onClick={handleContinue}>
//             Continue
//           </button>
//           <p>
//             Already have an account?{' '}
//             <span onClick={() => setShowSignup(false)} style={{ color: 'blue', cursor: 'pointer', textDecoration: 'underline' }}>
//               Login
//             </span>
//           </p>
//         </div>
//       )}

//       {step === 2 && (
//         <form onSubmit={handleSubmit}>
//           <h3>Sign Up to Continue</h3>
//           {error && <div className="error7799">{error}</div>}
//           <div className="row7799">
//             <div className="column7799">
//               <label>First Name:</label>
//               <input type="text" value={firstName} onChange={(e) => setFirstName(e.target.value)} required />
//             </div>
//             <div className="column7799">
//               <label>Last Name:</label>
//               <input type="text" value={lastName} onChange={(e) => setLastName(e.target.value)} required />
//             </div>
//           </div>
//           <div className="row7799">
//             <div className="column7799">
//               <label>Email:</label>
//               <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
//             </div>
//           </div>
//           <div className="row7799">
//             <div className="column7799">
//               <label>Password:</label>
//               <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
//             </div>
//             <div className="column7799">
//               <label>Confirm Password:</label>
//               <input type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required />
//             </div>
//           </div>
//           <button className="button37799" type="submit">
//             Signup
//           </button>
//           <p>
//             Already have an account?{' '}
//             <span onClick={() => setShowSignup(false)} style={{ color: 'blue', cursor: 'pointer', textDecoration: 'underline' }}>
//               Login
//             </span>
//           </p>
//         </form>
//       )}

//       {step === 3 && (
//         <form onSubmit={handleOtpSubmit} className="otpform556">
//           <center>
//             <div className="form-group556">
//               <p id="otp-sent556">OTP has been sent to your email ID!</p>
//               <input
//                 type="text"
//                 id="otp556"
//                 value={otp}
//                 onChange={(e) => setOtp(e.target.value)}
//                 placeholder="Enter OTP here"
//                 required
//               />
//             </div>
//           </center>
//           <button type="submit" className="verify-button556">
//             Verify OTP
//           </button>
//           <center>
//             <p id="otp-p556">{otpTimer > 0 ? `Resend OTP in ${otpTimer}s` : "Didn't receive an OTP?"}</p>
//           </center>
//           <button
//             type="button"
//             className="resend-button123556"
//             onClick={handleResendOtp}
//             disabled={resendDisabled}
//           >
//             Resend OTP
//           </button>
//           <p>
//             Already have an account?{' '}
//             <span onClick={() => setShowSignup(false)} style={{ color: 'blue', cursor: 'pointer', textDecoration: 'underline' }}>
//               Login
//             </span>
//           </p>
//         </form>
//       )}

//       {step === 4 && (
//         <div className="success-message556">
//           <img src="https://media.tenor.com/WsmiS-hUZkEAAAAj/verify.gif" height="200px" width="200px" alt="success" />
//           <h3 style={{ color: 'green' }}>Signup Complete!</h3>
//           <button onClick={() => setShowSignup(false)} style={{ color: 'white', cursor: 'pointer' }} className="login-button556">
//             Proceed to Login
//           </button>
//         </div>
//       )}
//     </div>
//   );
// }

// export default SignupContainer;




import React, { useState, useEffect, useRef } from 'react';
import './Signup.css';
import { useNavigate } from 'react-router-dom';
import LoginPopup from './LoginPopup';
import emailjs from 'emailjs-com';
import { useContext } from "react";
import AlertContext from "../../contexts/AlertContext";

function SignupContainer({ setShowSignup }) {
  const [visible, setVisible] = useState(true); // internal visibility fallback
  const [step, setStep] = useState(1);
  const [profileFor, setProfileFor] = useState('');
  const [gender, setGender] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [mobile, setMobile] = useState("");
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState(null);
  const [showLogin, setShowLogin] = useState(false);
  const [generatedOtp, setGeneratedOtp] = useState('');
  const [otpTimer, setOtpTimer] = useState(60);
  const [resendDisabled, setResendDisabled] = useState(true);
  const [otpValid, setOtpValid] = useState(true);
  const { showAlert } = useContext(AlertContext);

  const navigate = useNavigate();
  const [otp, setOtp] = useState(["", "", "", "", ""]); // 5 digits
  const inputRefs = useRef([]);

  const handleOtpChange = (e, index) => {
    let value = e.target.value;

    // Allow empty value (for backspace)
    if (value === "") {
      const updatedOtp = [...otp];
      updatedOtp[index] = "";
      setOtp(updatedOtp);

      // Move focus backward if not the first box
      if (index > 0) {
        inputRefs.current[index - 1].focus();
      }
      return;
    }

    // Allow only digits & only ONE digit per box
    value = value.replace(/\D/g, "").slice(0, 1);

    const updatedOtp = [...otp];
    updatedOtp[index] = value;
    setOtp(updatedOtp);

    // Auto move to next box
    if (index < 4) {
      inputRefs.current[index + 1].focus();
    }
  };

  useEffect(() => {
    let countdown;

    if (step === 3 && otpTimer > 0) {
      countdown = setInterval(() => {
        setOtpTimer((prev) => prev - 1);
      }, 1000);
    }

    if (otpTimer === 0) {
      clearInterval(countdown);
      setOtpValid(false);
      setResendDisabled(false);
    }

    return () => clearInterval(countdown);
  }, [otpTimer, step]);

  const generateOtp = () => {
    const otpCode = Math.floor(10000 + Math.random() * 90000).toString();
    setGeneratedOtp(otpCode);
    setOtpTimer(60);
    setOtpValid(true);
    setResendDisabled(true);

    const templateParams = {
      to_email: email,
      otp: otpCode,
    };

    emailjs
      .send('service_cmd3h5y', 'template_gome033', templateParams, 'DMFmcREENW-DkL8wt')
      .then(() => {
        showAlert('OTP sent to your email!');
      })
      .catch((error) => {
        console.error('Error sending OTP: ', error);
        showAlert('Failed to send OTP. Please try again.', "error");
      });
  };


  // helper to close modal (tries parent setter, else uses internal state)
  const closeModal = (e) => {
    if (e && typeof e.preventDefault === 'function') e.preventDefault();
    if (e && typeof e.stopPropagation === 'function') e.stopPropagation();
    console.log('closeModal called. setShowSignup is:', typeof setShowSignup);

    if (typeof setShowSignup === 'function') {
      setShowSignup(false);
    } else {
      // fallback: hide locally if parent didn't provide setter
      setVisible(false);
    }
  };

  // close on Escape
  useEffect(() => {
    const onKey = (ev) => {
      if (ev.key === 'Escape') {
        closeModal();
      }
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, []);

  // if internal fallback used and not visible, don't render
  if (!visible) return null;

  const handleProfileSelect = (option) => {
    setProfileFor(option);
    if (option === 'My Son' || option === 'My Brother') setGender('Male');
    else if (option === 'My Daughter' || option === 'My Sister') setGender('Female');
    else setGender('');
  };

  const handleGenderSelect = (option) => setGender(option);

  const handleContinue = () => {
    if (profileFor && gender) setStep(2);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      setError('Passwords do not match!');
      return;
    }

    setError(null);
    generateOtp();
    setStep(3);
  };
  const handleOtpSubmit = async (e) => {
    e.preventDefault();

    if (!otpValid) {
      showAlert("OTP has expired. Please resend OTP.", "error");
      return;
    }



    // ✔ OTP verified
    showAlert("OTP verified successfully!");

    const userData = {
      firstName,
      lastName,
      email,
      password,
      mobile,
      gender,
      profileFor,
    };

    try {
      const response = await fetch("https://back.varankal.com/auth/signup", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(userData),
      });

      const data = await response.json();

      // ❌ Backend error (email exists / duplicate / validation failed)
      if (!response.ok) {
        showAlert(data.message || "Registration failed!");
        return;
      }

      // ✔ Backend success → move next step
      setStep(4);

    } catch (error) {
      console.error("Error during registration:", error);
      showAlert("Server error. Please try again.", "error");
    }
  };


  const handleResendOtp = () => {
    generateOtp();
  };


  const handleProceedToLogin = () => setShowLogin(true);

  return (
    <>
      {!showLogin && (
        <div
          className="signup-overlay9090"
          /* clicking overlay should close — keep this if desired, else remove onClick */
          onClick={closeModal}
          style={{ zIndex: 1000 }}
        >
          <div
            className={`signup-popup9090 step-${step}`}
            onClick={(e) => e.stopPropagation()}
            style={{ position: 'relative', zIndex: 1001 }}
          >
            {/* Important: explicit type="button" */}
            <button
              type="button"
              aria-label="Close signup"
              className="close-btn9090"
              onClick={closeModal}
            >
              ✖
            </button>

            {/* Logo Section */}
            <div className="logo-section9090">
              <img
                src="/Images/icon tm.png"
                alt="Varankal Logo"
                className="signup-logo9090"
              />
            </div>

            {/* --- rest of your steps --- */}

            {step === 1 && (
              <div className="step-container fade-in">
                <h3 className="step-title">This Profile is for</h3>
                <div className="profile-grid">
                  {['Myself', 'My Son', 'My Daughter', 'My Brother', 'My Sister', 'My Friend'].map(
                    (option) => (
                      <button
                        key={option}
                        type="button"
                        className={`profile-btn ${profileFor === option ? 'active' : ''}`}
                        onClick={() => handleProfileSelect(option)}
                      >
                        {option}
                        {profileFor === option && <span className="tick">✔</span>}
                      </button>
                    )
                  )}
                </div>

                {(profileFor === 'Myself' || profileFor === 'My Friend') && (
                  <div className="gender-section fade-in">
                    <h4>Gender</h4>
                    <div className="gender-options">
                      {['Male', 'Female'].map((g) => (
                        <button
                          key={g}
                          type="button"
                          className={`gender-btn ${gender === g ? 'active' : ''}`}
                          onClick={() => handleGenderSelect(g)}
                        >
                          {g}
                          {gender === g && <span className="tick">✔</span>}
                        </button>
                      ))}
                    </div>
                  </div>
                )}

                <button
                  type="button"
                  className="continue-btn"
                  disabled={!profileFor || !gender}
                  onClick={handleContinue}
                >
                  Continue →
                </button>
              </div>
            )}

            {step === 2 && (
              <form onSubmit={handleSubmit} className="fade-in signup-form9090">
                <h3 className="step-title">Sign Up to Continue</h3>
                {error && <div className="error7799">{error}</div>}

                <div className="input-row9090">
                  <div className="input-group9090">
                    <label>First Name</label>
                    <input
                      className="input-field9090"
                      type="text"
                      value={firstName}
                      onChange={(e) => setFirstName(e.target.value)}
                      required
                    />
                  </div>
                  <div className="input-group9090">
                    <label>Last Name</label>
                    <input
                      className="input-field9090"
                      type="text"
                      value={lastName}
                      onChange={(e) => setLastName(e.target.value)}
                      required
                    />
                  </div>
                </div>

                <div className="input-row9090">
                  <div className="input-group9090">
                    <label>Email</label>
                    <input
                      className="input-field9090"
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </div>

                  <div className="input-group9090">
                    <label>Mobile Number</label>
                    <input
                      className="input-field9090"
                      type="text"
                      value={mobile}
                      onChange={(e) => setMobile(e.target.value)}
                      required
                    />
                  </div>
                </div>



                <div className="input-row9090">
                  <div className="input-group9090">
                    <label>Password</label>
                    <input
                      className="input-field9090"
                      type="password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                  </div>
                  <div className="input-group9090">
                    <label>Confirm Password</label>
                    <input
                      className="input-field9090"
                      type="password"
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      required
                    />
                  </div>
                </div>

                <div className="button-row">
                  <button type="button" className="back-btn9090" onClick={() => setStep(1)}>
                    ← Back
                  </button>
                  <button className="button377949" type="submit">
                    Signup
                  </button>
                </div>
              </form>
            )}

            {step === 3 && (
              <form onSubmit={handleOtpSubmit} className="otpform5566">

                <center>
                  <div className="form-group5566">
                    <p id="otp-sent5566">OTP has been sent to your email ID!</p>

                    {/* OTP BOXES */}
                    <div className="otp-box-container5566">
                      {otp.map((digit, index) => (
                        <input
                          key={index}
                          type="text"
                          maxLength="1"
                          className="otp-input-box5566"
                          value={digit}
                          onChange={(e) => handleOtpChange(e, index)}
                          ref={(el) => (inputRefs.current[index] = el)}
                        />
                      ))}
                    </div>

                  </div>
                </center>

                <button type="submit" className="verify-button5566">
                  Verify OTP
                </button>

                <center>
                  <p id="otp-p556">
                    {otpTimer > 0 ? `Resend OTP in ${otpTimer}s` : "Didn't receive an OTP?"}
                  </p>
                </center>

                <button
                  type="button"
                  className="resend-button1235566"
                  onClick={handleResendOtp}
                  disabled={resendDisabled}
                >
                  Resend OTP
                </button>

              </form>

            )}

            {step === 4 && (
              <div className="success-message556">
                <img
                  src="https://media.tenor.com/WsmiS-hUZkEAAAAj/verify.gif"
                  alt="success"
                  className="success-gif556"
                />

                <h3 className="success-title556">Signup Complete!</h3>

                <button
                  onClick={() => setShowSignup(false)}
                  className="success-login-btn556"
                >
                  Proceed to Login
                </button>
              </div>

            )}
          </div>
        </div>
      )}
      {showLogin && <LoginPopup onClose={() => setShowLogin(false)} />}
    </>
  );
}

export default SignupContainer;
